var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcImportData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8182 14.25H11.9407L13.8757 12.3075L12.8182 11.25L9.06818 15L12.8182 18.75L13.8757 17.6925L11.9407 15.75H21.8182V14.25Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8182 10.5V7.50001C18.8187 7.40131 18.7998 7.30346 18.7625 7.21208C18.7252 7.1207 18.6702 7.03759 18.6007 6.96751L13.3507 1.71751C13.2806 1.648 13.1975 1.59301 13.1061 1.55568C13.0147 1.51836 12.9169 1.49944 12.8182 1.50001H5.31818C4.92035 1.50001 4.53882 1.65805 4.25752 1.93935C3.97621 2.22066 3.81818 2.60219 3.81818 3.00001V21C3.81818 21.3978 3.97621 21.7794 4.25752 22.0607C4.53882 22.342 4.92035 22.5 5.31818 22.5H17.3182C17.716 22.5 18.0975 22.342 18.3788 22.0607C18.6601 21.7794 18.8182 21.3978 18.8182 21V19.5H17.3182V21H5.31818V3.00001H11.3182V7.50001C11.3182 7.89784 11.4762 8.27937 11.7575 8.56067C12.0388 8.84198 12.4204 9.00001 12.8182 9.00001H17.3182V10.5H18.8182ZM12.8182 7.50001V3.30751L17.0107 7.50001H12.8182Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImportData);
export default __webpack_public_path__ + "static/media/ic-import-data.40a821a14e74191cc0ef7199760cf8a0.svg";
export { ForwardRef as ReactComponent };